var _rect, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 249,
    viewBox: "0 0 504 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 504,
    height: 249,
    rx: 20,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 110.5C225.26 189.452 303.688 186.997 432 110.5",
    stroke: "#7EE99F",
    strokeOpacity: 0.6,
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110.5C225.26 189.452 303.688 186.997 432 110.5",
    stroke: "#00D743",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 97,
    r: 15,
    fill: "#7EE99F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 97,
    r: 15,
    fill: "#7EE99F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/emoji-3.5166638663490b25fe2102f39d669090.svg";
export { ForwardRef as ReactComponent };